import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import CartDrawer from './components/CartDrawer';
import Footer from './components/Footer';
import AuthCallback from './components/AuthCallback';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import CoursesPage from './pages/CoursesPage';
import TrialLessonsPage from './pages/TrialLessonsPage';
import CheckoutPage from './pages/CheckoutPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import CheckoutCancelPage from './pages/CheckoutCancelPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import RentPage from './pages/RentPage';
import AccountPage from './pages/AccountPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import CookieBanner from './components/CookieBanner';
import ChatWidget from './components/ChatWidget';

function AppRouter() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1"><AuthCallback /></main>
        <Footer />
      </div>
    );
  }
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <CartDrawer />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/corsi" element={<CoursesPage />} />
          <Route path="/lezioni-prova" element={<TrialLessonsPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
          <Route path="/contatti" element={<ContactPage />} />
          <Route path="/affitta-sala" element={<RentPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/condizioni-vendita" element={<TermsPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
          <CookieBanner />
          <ChatWidget />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
